import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@services/user/user.service';
import { SessionService } from '@services/session/session.service';
import { ModalService } from '@common_libraries/controls/modal/services/modal.service';
import { ModuleAuth } from '@common_libraries/lib/ModuleAuth';
import {GoogleAnalyticsEventsService} from '@library/helpers/GoogleAnalyticsEvent.Service';
import { LocalStorageService } from 'ngx-webstorage';

interface CompanyJSON {
  name: string;
  companyID: number;
  sortOrder: number;
  theme: string;
}

export class CompanyModel {
  static fromJSON(json: CompanyJSON): CompanyModel {
    const company = Object.create(CompanyModel.prototype);
    return Object.assign(company, json, {});
  }

  static SortCompanies(companies: CompanyModel[]): CompanyModel[] {
    companies.sort((a, b) => {
      if (a.sortOrder === b.sortOrder) {
        return a.name > b.name ? 1 : -1;
      }
      return a.sortOrder - b.sortOrder;
    });

    return companies;
  }

  constructor(public name: string,
              public companyID: number,
              public sortOrder: number,
              public theme: string) {}
}

@Injectable()
export class CompanyPickerModel {
  public selectedCompany: CompanyModel;
  public companies: Array<CompanyModel>;

  constructor(private sessionService: SessionService,
              private userService: UserService,
              private router: Router,
              private modalService: ModalService,
              private moduleAuth: ModuleAuth,
              private google: GoogleAnalyticsEventsService,
              private localSt: LocalStorageService) {
  }

  public getCompanyList() {
    if (this.sessionService.GetIsLoggedIn()) {
      const prom = this.userService.GetCompaniesForUser();
      if (prom != null) {
        prom.subscribe((res: any) => {
            this.companies = res.json.data.map(company => CompanyModel.fromJSON(company));
            this.companies = CompanyModel.SortCompanies(this.companies);

            // Filter the list of companies by the company in our localstorage - if we have one
            const pCompany = this.companies.filter(c => {
              return c.companyID === this.sessionService.GetSelectedCompanyID();
            });

            // To get this far, the user should definitely have a company in localstorage as it gets set on login screen
            // otherwise that means the user cleared their cache and shouldnt be here anyways...
            if (pCompany.length > 0) {
              this.selectedCompany = pCompany[0];
            } else {
              // I guess if they somehow lose their local storage, we can go ahead and set them to the first company in their list?
              this.selectedCompany = this.companies[0];
              this.sessionService.SetSelectedCompanyID(this.selectedCompany);
              this.moduleAuth.SetupModuleAuthData().subscribe((mod: any) => {});
            }

          },
          err => {

          });
      }
      return prom;
    }
    return null;
  }

  public selectCompany(company: CompanyModel) {
    this.google.emitEvent(  'Company', company.name, null, null);
    // console.log('setting selectedCompany', this.companies[0]);
    this.selectedCompany = company;
    
    // We don't want to set the body class here. The page is going to refresh and it will take effect
    // Otherwise you get a wierd effect where the theme changes in the background, then the page refreshes as expected
    // It makes the site seem like the refresh is unnecessary
    if (company.theme !== undefined && company.theme !== null) {
      // document.body.className = company.theme;
      this.localSt.store('Theme', company.theme);
    } else {
      // document.body.className = 'default';
      this.localSt.store('Theme', 'default');
    }
    
    this.sessionService.SetSelectedCompanyID(company);

    this.moduleAuth.SetupModuleAuthData().subscribe((result: any) => {
      window.location.href = '/';
      this.modalService.close('account-select-modal');
    });
  }
}
